import { render, staticRenderFns } from "./TaskTypeRegister.vue?vue&type=template&id=7d81094c&"
import script from "./TaskTypeRegister.vue?vue&type=script&lang=js&"
export * from "./TaskTypeRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports